export default () => ({
    errorMsg: null,
    successMsg: null,
    isLoading: null,
    highlightAddress: '',
    highlightMethod: '',
    highlightTx: '',
    displayDecimals: 'dynamic', // fixed, dynamic
});
